<template>
  <b-row>
  </b-row>
</template>
<script>
import SidebarLink from './SidebarLink.vue'

export default {
  components: {
    SidebarLink
  },
  props: {
    title: {
      type: String,
      default: 'UTM5 5.4.001'
    },
    imgLogo: {
      type: String,
      default: require('@/assets/img/logo.png')
    },
    activeColor: {
      type: String,
      default: 'green',
      validator: value => {
        let acceptedValues = ['', 'purple', 'blue', 'green', 'orange', 'red']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide () {
    return {
      autoClose: this.autoClose
    }
  },
  methods: {
    logout: function () {
      this.$cookie.delete('session_id')
      this.$router.push('login')
    }
  },
  computed: {
    sidebarStyle () {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      }
    }
  }
}
</script>
<style>
@media screen and (min-width: 991px) {
  .nav-mobile-menu {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sidebarPlugin/SideBar.vue